import React, { useState } from "react";
import { FaRegClone } from "react-icons/fa6";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Popover } from "flowbite-react";
import { Tooltip, IconButton } from "@mui/material";

const CopyButton = ({ textToCopy }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1000); // Reset copied state after 2 seconds
  };

  return (
    <div className="relative my-auto inline-block">
      <div className="h-2/4">
        <CopyToClipboard text={textToCopy} onCopy={handleCopy}>
          <Tooltip title="Copy key" className="h-3/4">
            <IconButton>
              <FaRegClone />
            </IconButton>
          </Tooltip>
        </CopyToClipboard>
      </div>
      {copied && (
        <div className="w-50 absolute text-sm text-gray-500 dark:text-gray-400">
          <div className="border-b border-gray-200 bg-gray-100 px-3 py-2 dark:border-gray-600 dark:bg-gray-700">
            <p className="font-semibold text-gray-900 dark:text-white">
              Copied!
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CopyButton;
